import { useEffect, useLayoutEffect, useState } from "react";
import { errorText } from "../../shared/toastHelper";
import focusField from "./focusField";

let sessionSeq = 0;
export const newSessionKey = () => `new-${(sessionSeq += 1)}`;

export const toggleChecked = (e) => (e?.target ? e.target.checked : e);

export default function useWizardSteps({ steps, initialStep = 0, isEditing, isStepComplete, canVisit, resetOn }) {
  const [step, setStep] = useState(initialStep);
  const [maxStepReached, setMaxStepReached] = useState(initialStep);
  const [saving, setSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [focusRequest, setFocusRequest] = useState(null);

  useLayoutEffect(() => {
    setErrorMessage(null);
    setFieldErrors({});
  }, resetOn);

  useEffect(() => {
    if (focusRequest) focusField(focusRequest.field);
  }, [focusRequest]);

  const visitable = (index) => (canVisit ? canVisit(index, maxStepReached) : index <= maxStepReached);
  const reach = (index) => {
    setStep(index);
    setMaxStepReached((m) => Math.max(m, index));
  };
  const goTo = (key) => {
    const index = steps.findIndex((s) => s.key === key);
    if (index >= 0 && visitable(index)) reach(index);
  };

  const showProblem = ({ step: index, field, message, inline }) => {
    reach(index);
    setErrorMessage(message);
    if (!inline) setFieldErrors({ [field]: message });
    setFocusRequest({ field });
  };

  const startSaving = () => {
    setSaving(true);
    setErrorMessage(null);
  };

  const failSave = (e, fallback) => {
    setErrorMessage(errorText(e, fallback));
    setFocusRequest({ field: "wizard-error" });
    setSaving(false);
  };

  return {
    step,
    stepKey: steps[step].key,
    lastStep: step === steps.length - 1,
    saving,
    setSaving,
    fieldErrors,
    goTo,
    showProblem,
    startSaving,
    failSave,
    shellProps: {
      errorMessage,
      steps: steps.map((s, i) => ({
        key: s.key,
        label: s.label,
        icon: s.icon,
        state: i === step ? "current" : (isEditing || i <= maxStepReached) && isStepComplete(i) ? "complete" : "upcoming",
        navigable: visitable(i),
      })),
      onStepClick: goTo,
      stepTitle: steps[step].label,
      stepSubtitle: steps[step].subtitle,
    },
    footerProps: {
      onBack: () => setStep((s) => Math.max(0, s - 1)),
      backDisabled: saving || step === 0,
      nextLabel: steps[step + 1]?.label,
      onNext: () => reach(Math.min(steps.length - 1, step + 1)),
    },
  };
}
